import React, { useState } from "react";
import { Container, Paper, TextField, Button, Typography, Box, Alert, CircularProgress } from "@mui/material";
import { Add, Group } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { groupService } from "../services/group.service";

const CreateGroup: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!name.trim()) {
      setError("O nome do grupo é obrigatório");
      setLoading(false);
      return;
    }

    try {
      await groupService.create({ name, description });
      alert("Grupo criado com sucesso!");
      navigate("/dashboard");
    } catch (err: any) {
      setError(err.response?.data?.message || "Erro ao criar grupo");
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <Container component="main" maxWidth="sm">
        <Box sx={{ mt: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Alert severity="warning" sx={{ width: "100%", mb: 2 }}>
            Você precisa estar logado para criar grupos.
          </Alert>
          <Button variant="contained" onClick={() => navigate("/login")} sx={{ mt: 2 }}>
            Fazer Login
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ mt: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Group sx={{ fontSize: 40, color: "primary.main", mb: 2 }} />
            <Typography component="h1" variant="h4" gutterBottom>
              Criar Novo Grupo
            </Typography>

            {error && (
              <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: "100%" }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="groupName"
                label="Nome do Grupo"
                name="groupName"
                autoComplete="group-name"
                autoFocus
                value={name}
                onChange={(e) => setName(e.target.value)}
                helperText="Digite um nome único para identificar o grupo"
              />
              <TextField
                margin="normal"
                fullWidth
                id="groupDescription"
                label="Descrição (opcional)"
                name="groupDescription"
                multiline
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                helperText="Descreva o propósito deste grupo de senhas"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{ mt: 3, mb: 2 }}
                startIcon={loading ? <CircularProgress size={20} /> : <Add />}
              >
                {loading ? "Criando Grupo..." : "Criar Grupo"}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default CreateGroup;
